module.exports = __webpack_public_path__ + "static/media/thresh.a4b155f4.png";